module.exports = __webpack_public_path__ + "img/file-upload.d96930ce.png";